const PLAN_INDEX = Object.freeze({
  essential: 1,
  advanced: 2,
  supercharged: 3,
});

export default PLAN_INDEX;
